import SvgIcon from '@mui/material/SvgIcon'

export default function ArrowDropDownIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M 12.636 14.864 L 16.464 11.036 C 16.7212 10.7785 16.798 10.3914 16.6586 10.0552 C 16.5191 9.71904 16.191 9.49992 15.827 9.5 L 8.173 9.5 C 7.80905 9.49992 7.48087 9.71904 7.34145 10.0552 C 7.20203 10.3914 7.27881 10.7785 7.536 11.036 L 11.364 14.864 C 11.7154 15.2149 12.2846 15.2149 12.636 14.864 Z"/>
    </SvgIcon>
  )
}
